import Container from '~/components/container';
import Loading from '~/components/loading';
import * as S from './styles';
import { useHistory, useLocation } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import { useEffect, useState } from 'react';
import moment from 'moment';
import TableList from '~/components/tableList';
import { IListColCampaing } from '~/views/Resource/Campaing/model';
import ContainerFlex from '~/components/containerFlex';

type LocationState = {
  periodoFinal: string;
  periodoInicial: string;
  idAtendente: string;
  tipoAlerta: string;
};

const DetailsProposalColdRegistration = () => {
  const [list, setList] = useState([]);
  const { state } = useLocation<LocationState>();
  const history = useHistory();

  const customHeader = [
    {
      id: 1,
      value: 'Data',
      maxChar: 25,
      textAlign: 'center',
    },
    {
      id: 2,
      value: 'Operador',
      maxChar: 25,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Tipo de alerta',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Qtd propostas envolvidas',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 5,
      value: '% Pendência',
      maxChar: 20,
      textAlign: 'center',
    },
  ];

  console.log(state, 'state');

  const RequestGetColdRegistration = useApi<any>(
    Endpoints.graphc.getListAlerts
      .replace(
        'DATA_FINAL',
        moment(state?.periodoFinal, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      )
      .replace(
        'DATA_INICIAL',
        moment(state?.periodoInicial, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      )
      .replace('OPERADOR', state.idAtendente)
      .replace('TIPO_ALERTA', state.tipoAlerta),
    ApiMethod.GET,
  );

  const getAlertsColdRegistration = async () => {
    try {
      const responseAlertCold = await RequestGetColdRegistration.callApi();

      if (responseAlertCold.status !== 200) {
        setList([]);
        return;
      }

      if (responseAlertCold.status >= 200 && responseAlertCold.status < 300) {
        const { data } = responseAlertCold;

        const { alertas } = data;

        const newList = [];

        alertas.forEach((alert) => {
          const item: IListColCampaing[] = [
            {
              id: 1,
              border: true,
              title: 'Data',
              value: alert.data,
              maxChar: 25,
              textAlign: 'center',
            },
            {
              id: 2,
              border: true,
              title: 'Operador',
              value: alert.operador,
              maxChar: 20,
              textAlign: 'center',
            },
            {
              id: 3,
              border: true,
              title: 'Tipo de alerta',
              value: alert.tipoAlerta,
              maxChar: 20,
              textAlign: 'center',
            },
            {
              id: 4,
              border: true,
              title: 'Qtd propostas envolvidas',
              value: alert.quantidade ? alert.quantidade : ' - ',
              maxChar: 20,
              textAlign: 'center',
            },
            {
              id: 5,
              border: true,
              title: '% Pendência',
              value: alert.percentual ? alert.percentual : ' - ',
              maxChar: 20,
              textAlign: 'center',
            },
          ];
          newList.push(item);
        });
        setList(newList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAlertsColdRegistration();
  }, [state]);

  return (
    <Container>
      <Loading status={RequestGetColdRegistration.loading}/>
      <S.Header>
        <S.LeftSide>
          <FiArrowLeft onClick={() => history.goBack()} />
          <S.HeaderTitle onClick={() => history.goBack()}>
            <S.Title>Detalhes dos alertas de cadastro frio</S.Title>
          </S.HeaderTitle>
        </S.LeftSide>
      </S.Header>
      <S.MonthCardItem>
        {list.length > 0 ? (
          <ContainerFlex center>
            <TableList customerHeader={customHeader} list={list} />
          </ContainerFlex>
        ) : (
          <ContainerFlex>
            <S.TitleCategory style={{ width: 'auto' }}>
              Nenhum alerta encontrado.
            </S.TitleCategory>
          </ContainerFlex>
        )}
      </S.MonthCardItem>
    </Container>
  );
};

export default DetailsProposalColdRegistration;
